// Better Auth React client (T04 §9.5). Same origin in the single container; the Vite dev proxy forwards
// /api to :3000, so no base URL is hardcoded. adminClient/twoFactorClient add `role` and `twoFactorEnabled`
// to the inferred user type, so no type import from the server is needed (dependency direction, C06).
import { createAuthClient } from "better-auth/react";
import { adminClient, inferAdditionalFields, twoFactorClient } from "better-auth/client/plugins";
import { ac, roles } from "@vbltc/schema/permissions";
import { resilientFetch } from "@/api/resilient-fetch";

export const authClient = createAuthClient({
  baseURL: window.location.origin,
  basePath: "/api/auth",
  // J-210: a 429 on `/get-session` is waited out and sent again, never read as "signed out".
  fetchOptions: { credentials: "include", customFetchImpl: resilientFetch },
  plugins: [
    adminClient({ ac, roles }),
    // J-210 (inbox 06 PR E point 4): `login.tsx` opens /two-factor itself, keeping the page to return
    // to; the plugin's own `twoFactorPage` jump (`window.location.href`) dropped it.
    twoFactorClient({ onTwoFactorRedirect: () => undefined }),
    // J-244: the server's `user.mustChangePassword` (`plugins/auth.ts` additionalFields), declared here
    // rather than inferred from the server's type, which the web app may not import (C6).
    inferAdditionalFields({ user: { mustChangePassword: { type: "boolean", required: false } } }),
  ],
});
